export interface DescuentoJudicial {
  idDescuentoJudicial: number;
  idTrabajador: number;
  tipoDescuento: string;
  tipoCalculo: string;
  porcentaje: number;
  montoFijo: number;
  numeroExpediente: string | null;
  juzgado: string | null;
  beneficiario: string;
  dniBeneficiario: string | null;
  cuentaBancaria: string | null;
  banco: string | null;
  fechaInicio: string;
  fechaFin: string | null;
  motivo: string | null;
  estado: string;
  fechaRegistro: string;
  observaciones: string | null;
  trabajador?: {
    idTrabajador: number;
    personal?: { personaContacto?: string };
    area?: { descripcion?: string };
  };
}

export const TIPOS_DESCUENTO = [
  { value: 'PENSION_ALIMENTICIA', label: 'Pensión Alimenticia', color: '#ed6c02' },
  { value: 'EMBARGO_JUDICIAL', label: 'Embargo Judicial', color: '#d32f2f' },
];

export const TIPOS_CALCULO = [
  { value: 'PORCENTAJE', label: 'Porcentaje del neto' },
  { value: 'MONTO_FIJO', label: 'Monto fijo' },
];

export const ESTADOS_DESCUENTO = [
  { value: 'ACTIVO', label: 'Activo', color: '#2e7d32' },
  { value: 'INACTIVO', label: 'Inactivo', color: '#757575' },
];

export const initialDescuentoJudicial: Partial<DescuentoJudicial> = {
  idDescuentoJudicial: 0,
  idTrabajador: 0,
  tipoDescuento: 'PENSION_ALIMENTICIA',
  tipoCalculo: 'PORCENTAJE',
  porcentaje: 0,
  montoFijo: 0,
  numeroExpediente: null,
  juzgado: null,
  beneficiario: '',
  dniBeneficiario: null,
  cuentaBancaria: null,
  banco: null,
  fechaInicio: new Date().toISOString().substring(0, 10),
  fechaFin: null,
  motivo: null,
  estado: 'ACTIVO',
  observaciones: null,
};
